const closeButtonLabel = "Sluit";
const nlBE = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  nlBE as default
};
